import { trackRazorpayCheckoutClosed, trackRazorpayCheckoutOpened } from "@/lib/analytics-chat";
import { trackEvent as trackOwnedEvent } from "@/lib/analytics-events";
import {
  trackReportCheckoutStarted,
  trackReportPurchased,
  trackRevenueCompleted,
} from "@/lib/analytics-checkout";
import { getAgentSessionId, recordAgentMemoryEvent } from "@/lib/agent-memory";
import { trackMetaPurchase } from "@/lib/checkout-event-context";
import {
  agenticCartMemoryPayload,
  agenticCartRazorpayPayload,
  agenticCartReportPayload,
  agenticCartRevenuePayload,
  agenticCartTrackingParams,
  type AgenticCartAttributionContext as TelemetryContext,
  type AgenticCartOrderAttributionContext as OrderTelemetryContext,
} from "./AgenticCartCheckout.attribution";

export function trackNativeBundleShown(ctx: TelemetryContext) {
  trackOwnedEvent("bundle_shown", agenticCartTrackingParams(ctx));
  trackOwnedEvent("agentic_cart_bundle_shown", agenticCartTrackingParams(ctx));
}

export function trackNativeCartOpened(ctx: TelemetryContext) {
  trackOwnedEvent("agentic_cart_opened", agenticCartTrackingParams(ctx));
}

export function recordNativeCheckoutStarted(ctx: OrderTelemetryContext) {
  recordAgentMemoryEvent(agenticCartMemoryPayload(ctx, "checkout_started", getAgentSessionId()));
  trackOwnedEvent("cart_created", agenticCartTrackingParams(ctx));
  trackOwnedEvent("agentic_cart_order_created", agenticCartTrackingParams(ctx));
  trackReportCheckoutStarted(agenticCartReportPayload(ctx));
}

export function trackNativeRazorpayOpened(ctx: OrderTelemetryContext) {
  trackOwnedEvent("checkout_started", agenticCartTrackingParams(ctx));
  trackRazorpayCheckoutOpened(agenticCartRazorpayPayload(ctx));
}

export function recordNativeCheckoutAbandoned(ctx: OrderTelemetryContext) {
  recordAgentMemoryEvent(agenticCartMemoryPayload(ctx, "checkout_abandoned", getAgentSessionId()));
  trackNativeRazorpayClosed(ctx, "dismissed");
}

export function trackNativeRazorpayClosed(
  ctx: OrderTelemetryContext,
  closeReason: "dismissed" | "payment_success" | "payment_failed" | "open_failed"
) {
  trackRazorpayCheckoutClosed({
    close_reason: closeReason,
    ...agenticCartRazorpayPayload(ctx),
  });
}

export function recordNativePurchaseCompleted(ctx: OrderTelemetryContext) {
  recordAgentMemoryEvent(agenticCartMemoryPayload(ctx, "purchase_completed", getAgentSessionId()));
  if (ctx.eventId) {
    trackMetaPurchase({ event_id: ctx.eventId, eventId: ctx.eventId }, ctx.bundle.price_inr);
  }
  trackOwnedEvent("agentic_cart_paid", {
    ...agenticCartTrackingParams(ctx),
    revenue_inr: ctx.bundle.price_inr,
  });
  trackOwnedEvent("paid", {
    ...agenticCartTrackingParams(ctx),
    revenue_inr: ctx.bundle.price_inr,
  });
  trackNativeRazorpayClosed(ctx, "payment_success");
  trackReportPurchased({
    order_id: ctx.order.razorpay_order_id,
    ...agenticCartReportPayload(ctx),
  });
  trackRevenueCompleted(agenticCartRevenuePayload(ctx));
}
